import axios from 'axios';

/* const API_URL = '/auth/'; */
const API_URL = 'https://registration-api.fenixmma.com/auth/';

// Register user

const register = async (userData) => {
  const response = await axios.post(API_URL + 'register', userData);

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }

  return response.data;
};

// Login user

const login = async (userData) => {
  const response = await axios.post(API_URL + 'login', userData);

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }

  return response.data;
};

// Logout user

const logout = async () => {
  const response = await axios.post(API_URL + 'logout');
  localStorage.removeItem('user');
  return response.data;
};

const authService = {
  register,
  logout,
  login,
};

export default authService;
